export enum SkinActionTypes {
  SET_SKIN = 'SET_SKIN',
  SET_GLOBAL_CONFIG = 'SET_GLOBAL_CONFIG',
  SET_HEADER_CONFIG = 'SET_HEADER_CONFIG',
  SET_NAVIGATION_CONFIG = 'SET_NAVIGATION_CONFIG',
  SET_BUTTON_NAV_CONFIG = 'SET_BUTTON_NAV_CONFIG',
  SET_COMPONENT_CONFIG = 'SET_COMPONENT_CONFIG',
  SET_FOOTER_CONFIG = 'SET_FOOTER_CONFIG',
}
